import { render, staticRenderFns } from "./section-5.vue?vue&type=template&id=4710b203&"
import script from "./section-5.vue?vue&type=script&lang=js&"
export * from "./section-5.vue?vue&type=script&lang=js&"
import style0 from "./section-5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports